export const nanToUndefined = (value) =>
  Number.isNaN(value) ? undefined : value;
